import { OPTION_TIME_DURATION } from 'modules/admin/settings/custom-plans/constants';

export const renderTimeDuration = (is_lifetime, expiration_days) => {
  if (is_lifetime && expiration_days) {
    return '';
  }
  if (is_lifetime) {
    return 'Life time';
  }
  return expiration_days
    ? OPTION_TIME_DURATION?.find((x) => x?.value === expiration_days)?.label
    : '';
};
